import Permissions, { usePermissions } from '@app/src/auth/permissions'
import { Solutions } from '@app/src/wf-constants'
import navigationLinks from '@app/src/wf-constants/navigationLinks'
import React from 'react'
import { useIntl } from 'react-intl'
import type { MenuWrapperProps } from './LegacyMenuWrapper'
import MenuWrapper from './LegacyMenuWrapper'
import type { NavbarItemProps } from './LegacyNavbarItems'

const ProviderMenu: React.FC<NavbarItemProps> = ({ closeMenuDrawer }) => {
  const { formatMessage } = useIntl()
  const { getWithPermission } = usePermissions()

  const solution = getWithPermission({
    [Permissions.SOURCING_USER]: Solutions.Sourcing,
    [Permissions.INVESTMENT_USER]: Solutions.Investment,
    [Permissions.FINANCE_USER]: Solutions.Finance,
  })

  if (!solution) {
    return null
  }

  const menuItems: MenuWrapperProps['menuItems'] = [
    {
      title: formatMessage({ id: 'navbar.companies' }),
      link: navigationLinks.providers,
      permission: [Permissions.SOURCING_USER, Permissions.FINANCE_USER, Permissions.INVESTMENT_USER],
    },
    { title: formatMessage({ id: 'navbar.contacts' }), link: navigationLinks.contacts },
  ]

  return (
    <MenuWrapper
      closeMenuDrawer={closeMenuDrawer}
      menuItems={menuItems}
      activePaths={['/resource/']}
      title={formatMessage({ id: `navbar.${solution}` })}
    />
  )
}

export default ProviderMenu
